import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Box, MenuItem, Chip } from "@material-ui/core";
// import { Button, IconButton, Modal, InputBase, Paper, TextField, Select, FormControl, InputLabel, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery } from "@mui/material";
import { styled } from '@mui/material/styles';
import UserListHead from "src/components/user/UserListHead";
import { useTheme } from '@mui/material/styles';
import LoadingScreen from "src/components/LoadingScreen";
import { useLocation } from "react-router";
const _ = require('lodash');

const OrderDetail = () => {

   const { state } = useLocation();
   const orderDetailData = state?.orderDetails?.item;
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const [loding, setLoding] = useState(false);

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'item_name', label: 'Item Name', alignRight: false },
      { id: 'quantity', label: 'quantity', alignRight: false },
      { id: 'total', label: 'total', alignRight: false },
      // { id: 'description', label: 'Description', alignRight: false },
      // { id: 'category name', label: 'Category name', alignRight: false },
      // { id: 'menu name', label: 'Menu name', alignRight: false },
      // { id: 'order number', label: 'order number', alignRight: false },
      // { id: 'status', label: 'Status', alignRight: false },
      // { id: 'action', label: 'Action', alignRight: false },
   ];

   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };

   return (
      <>
         {loding ? <LoadingScreen /> : <>
            <div className="dashboard_header mb-4">
               <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Order Details</h4>
            </div>
            <Card>
               <TableContainer>
                  <Table>
                     <UserListHead
                        headLabel={TABLE_HEAD}
                        // rowCount={foodItemList?.data?.length}
                        onRequestSort={handleRequestSort}
                     />
                     {orderDetailData?.length > 0 ?
                        <TableBody>
                           {orderDetailData.map((row) => {
                              return (
                                 <StyledTableRow key={row._id}>
                                    <TableCell component="th" scope="row">
                                       {row.item_name}
                                    </TableCell>
                                    <TableCell align="left"> {row.quantity}</TableCell>
                                    <TableCell align="left"> {row.total}</TableCell>
                                 </StyledTableRow>
                              )
                           })}
                           <StyledTableRow>
                              <TableCell component="th" scope="row">
                                 <b>Total Ammount: {state?.orderDetails?.total_ammount}</b>
                              </TableCell>
                           </StyledTableRow>
                        </TableBody>
                        :
                        <TableBody>
                           <TableRow>
                              <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                 <span className="app_text_16_semibold">No Data Found</span>
                              </TableCell>
                           </TableRow>
                        </TableBody>}

                  </Table>
               </TableContainer>
            </Card>
         </>
         }
      </>
   )
}

export default OrderDetail